import React, { Children, useState, useEffect } from "react"
import { cn } from "lib/utils" 

export function useDynamicLayout({ init="expanded" }:{ init?:string}){
  const [ expandedState, setExpandedState ] = useState(init === "expanded" ? true : false)
  const toggleExpanded = () => setExpandedState(!expandedState)
  
  function DynamicWidthLayout(props:any){
    return <DynamicWidthLayoutComponent {...props} expandedState={expandedState} setExpandedState={setExpandedState}>
      { props.children }
    </DynamicWidthLayoutComponent>
  }

  return { DynamicWidthLayout, toggleExpanded, expandedState }
}

function DynamicWidthLayoutComponent({
  expandedWidths=[],
  collapsedWidths=[],
  initialState="collapsed",
  expandedState=false,
  setExpandedState=() => {},
  className,
  children 
} : {
  expandedWidths?:string[];
  collapsedWidths?:string[];
  initialState?:string;
  expandedState?:boolean;
  setExpandedState?:Function;
  className?:string;
  children?:React.ReactNode;
}){

  // useEffect(() => {
  //   if( initialState === "expanded" ){
  //     setExpandedState(true)
  //   } else {
  //     setExpandedState(false)
  //   }
  // },[])

  return (
    <div className={cn("w-full flex justify-start items-start", className )}>
      { Children.map( children, (child:any, idx:number) => (
        <div 
          key={idx} 
          className={cn( "", expandedState ? expandedWidths[idx] : collapsedWidths[idx])}
        >
          { child }
        </div>
      ))}
    </div>
  )
}